import script from "./lto-record.vue?vue&type=script&setup=true&lang=js"
export * from "./lto-record.vue?vue&type=script&setup=true&lang=js"

import "./lto-record.vue?vue&type=style&index=0&id=9213df90&scoped=true&lang=css"

import exportComponent from "/home/dev.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9213df90"]])

export default __exports__